var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorseclock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.75C4.05562 1.75 1.25 4.55562 1.25 8C1.25 11.4444 4.05562 14.25 7.5 14.25C10.9444 14.25 13.75 11.4444 13.75 8C13.75 4.55562 10.9444 1.75 7.5 1.75ZM7.5 3C10.2688 3 12.5 5.23117 12.5 8C12.5 10.7688 10.2688 13 7.5 13C4.73117 13 2.5 10.7688 2.5 8C2.5 5.23117 4.73117 3 7.5 3ZM6.875 4.25V8.25879L9.55811 10.9419L10.4419 10.0581L8.125 7.74121V4.25H6.875Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorseclock);
export default __webpack_public_path__ + "static/media/corseclock.1a535c7230bf18b0c67095a9a0a69046.svg";
export { ForwardRef as ReactComponent };